import commonMessages from 'translations/common';

export type ErrorCode = Record<string, { id: string; defaultMessage: string }>;

export const customersErrorCodes: ErrorCode = {
  RESTRICTION_EVENT_START_TIME_AFTER_END_TIME: commonMessages.startDateTimeAfterEnd,
};
